import { useState } from "react";
import Aos from "aos";
import { useEffect } from "react";

const schedules = ["Daily", "Weekly", "Monthly"];

const BankvoleAutoDebitSection = () => {
  const [active, setActive] = useState("Weekly");

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  return (
    <section className="bv-autodebit">
      <div className="bv-autodebit-left" data-aos="fade-down" data-aos-duration="1000">
        <span className="bv-eyebrow">AUTOMATE YOUR PLANS</span>
        <h2 className="bv-autodebit-title">
          Build discipline with smart auto-debits.
        </h2>
        <p className="bv-autodebit-text">
          Stay consistent by automating your plan either daily, weekly, or
          monthly using a linked card or bank account payment method and
          build discipline without worrying about every payment.
        </p>
      </div>

      <div className="bv-autodebit-right" data-aos="fade-up" data-aos-duration="1000">
        <div className="bv-schedule-card">
          <p className="bv-schedule-label">AUTO-DEBIT SCHEDULE</p>
          {schedules.map((schedule) => (
            <button
              key={schedule}
              className={`bv-schedule-row ${
                schedule === active ? "bv-schedule-row--active" : ""
              }`}
              onClick={() => setActive(schedule)}
            >
              <span>{schedule}</span>
              <span className="bv-schedule-status">
                {schedule === active ? "Active" : "Available"}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BankvoleAutoDebitSection;
